/* Proceso DD OCDE · 6 etapas — catálogo copiado del prototipo v8 (DD6_STAGES).
 * Requisitos textuales de la Guía OCDE (Due Diligence Guidance for Responsible
 * Business Conduct). Las etapas 2 y 3 enlazan a los módulos existentes. */

export const DD6_STAGES = [
  {
    id: "s1", n: 1, code: "Sección I.1", page: "pág. 35", color: "#7B61C9",
    title: "Incorporar la CER en la política y los sistemas de gestión",
    intro: "Diseñá y adoptá explícitamente políticas de conducta empresarial responsable (CER) basadas en las Líneas Directrices de la OCDE, integralas en la estructura de gestión y comunicá tus expectativas a los socios comerciales.",
    linksTo: null,
    reqs: [
      { c: "1.1", t: "Adoptar y publicar políticas de CER",
        b: "Elaborar y adoptar explícitamente políticas de conducta empresarial responsable basadas en las Líneas Directrices de la OCDE, y publicar información sobre esas políticas." },
      { c: "1.2", t: "Revisar y actualizar periódicamente",
        b: "Revisar y actualizar de forma periódica las políticas de CER existentes." },
      { c: "1.3", t: "Integrar en la estructura de gestión",
        b: "Integrar las políticas de CER en la estructura de gestión y los órganos de supervisión de la empresa, para que se implementen como parte de los procesos habituales del negocio." },
      { c: "1.4", t: "Capacitar a los trabajadores",
        b: "Proveer capacitación a los trabajadores sobre las políticas de CER." },
      { c: "1.5", t: "Comunicar expectativas a socios comerciales",
        b: "Comunicar las expectativas de la empresa en materia de CER a los proveedores y otros socios comerciales." },
    ],
  },
  {
    id: "s2", n: 2, code: "Sección I.2", page: "pág. 43", color: "#3A6FB0",
    title: "Identificar daños reales y potenciales en las operaciones y la cadena",
    intro: "Realizá una evaluación de riesgos para identificar operaciones y relaciones comerciales con impactos adversos, priorizá los más graves y evaluá el grado de involucramiento de la empresa (causa, contribución o vínculo directo).",
    linksTo: { label: "Implementado en Risk Register (2.1) y Autoevaluación (2.2)", modules: ["rr","ae"] },
    reqs: [
      { c: "2.1", t: "Evaluación de riesgos",
        b: "Realizar una evaluación de riesgos para identificar operaciones y relaciones comerciales con impactos adversos potenciales o reales, enfocándose en los riesgos para las personas afectadas (trabajadores, comunidades), no en los riesgos para la empresa." },
      { c: "2.2", t: "Priorizar los impactos más graves",
        b: "Usar la evaluación de riesgos para identificar los impactos adversos más graves y priorizarlos en consecuencia." },
      { c: "2.3", t: "Evaluar el involucramiento",
        b: "Evaluar el involucramiento de la empresa con cada impacto: si lo causa, contribuye a él, o está directamente vinculada a través de una relación comercial." },
      { c: "2.4", t: "Definir qué abordar primero",
        b: "Identificar qué impactos adversos deben abordarse primero, según su gravedad y el grado de involucramiento de la empresa." },
    ],
  },
  {
    id: "s3", n: 3, code: "Sección I.3", page: "pág. 61", color: "#D97A34",
    title: "Detener, prevenir o mitigar los daños",
    intro: "Detené las actividades que causan o contribuyen a impactos adversos, elaborá planes para prevenir y mitigar impactos futuros, y definí claramente qué esperás de tus socios comerciales.",
    linksTo: { label: "Implementado en CAP Tracker (3.1)", modules: ["cap"] },
    reqs: [
      { c: "3.1", t: "Detener actividades dañinas",
        b: "Detener las actividades que están causando o contribuyendo a impactos adversos." },
      { c: "3.2", t: "Planes de prevención y mitigación",
        b: "Usar los hallazgos de la evaluación de riesgos para elaborar planes que prevengan y mitiguen impactos adversos futuros." },
      { c: "3.3", t: "Gestionar relaciones comerciales vinculadas",
        b: "Ante un vínculo directo con un impacto adverso, decidir el curso de acción (continuar, suspender temporalmente o terminar la relación), habiendo hecho todo lo posible por mejorar la situación antes de terminarla, y considerando los impactos sociales y económicos de esa decisión." },
      { c: "3.4", t: "Definir expectativas a socios",
        b: "Establecer claramente qué se espera de proveedores, compradores y otros socios comerciales en materia de CER." },
    ],
  },
  {
    id: "s4", n: 4, code: "Sección I.4", page: "pág. 73", color: "#E8B84B",
    title: "Seguimiento de la implementación y los resultados",
    intro: "Monitoreá periódicamente la implementación y la efectividad de tus medidas de debida diligencia, evaluá si tus socios comerciales también toman medidas, y usá las lecciones aprendidas para mejorar el proceso.",
    linksTo: null,
    reqs: [
      { c: "4.1", t: "Monitorear implementación y efectividad",
        b: "Monitorear de forma periódica la implementación y la efectividad de las medidas de debida diligencia de la empresa." },
      { c: "4.2", t: "Alcance del seguimiento",
        b: "Incluir en el seguimiento las medidas de identificación, prevención y mitigación de impactos adversos, así como el apoyo a la reparación." },
      { c: "4.3", t: "Evaluar a los socios comerciales",
        b: "Evaluar si los socios comerciales también están tomando medidas para mitigar los impactos adversos." },
      { c: "4.4", t: "Aprender y mejorar el proceso",
        b: "Usar las lecciones aprendidas en el proceso de seguimiento para mejorar el proceso de debida diligencia." },
    ],
  },
  {
    id: "s5", n: 5, code: "Sección I.5", page: "pág. 79", color: "#2E9461",
    title: "Comunicar cómo se abordan los impactos",
    intro: "Publicá información sobre tus políticas de CER y sé transparente sobre las medidas tomadas para abordar los impactos adversos, incluida su efectividad, de forma fácilmente accesible.",
    linksTo: null,
    reqs: [
      { c: "5.1", t: "Publicar políticas y medidas",
        b: "Publicar información sobre las políticas de CER y ser transparente sobre las medidas que se están tomando para abordar los impactos adversos, incluida su efectividad (por ejemplo, en el reporte anual u otras comunicaciones públicas de sustentabilidad o CER)." },
      { c: "5.2", t: "Accesibilidad de la información",
        b: "Publicar la información anterior de forma que sea fácilmente accesible." },
    ],
  },
  {
    id: "s6", n: 6, code: "Sección I.6", page: "pág. 83", color: "#B23030",
    title: "Reparar o cooperar en la reparación cuando corresponda",
    intro: "Proveé acceso a la reparación o cooperá en ella cuando la empresa causó o contribuyó a impactos adversos, asegurá un mecanismo de quejas para las partes afectadas, y considerá mecanismos legítimos como el Punto Nacional de Contacto (PNC).",
    linksTo: null,
    reqs: [
      { c: "6.1", t: "Proveer o cooperar en la reparación",
        b: "Proveer acceso a la reparación, o cooperar en ella, cuando la empresa haya causado o contribuido a impactos adversos." },
      { c: "6.2", t: "Mecanismo de quejas",
        b: "Asegurar que la empresa cuente con un mecanismo de quejas para que cualquier parte afectada pueda presentar su reclamo." },
      { c: "6.3", t: "Mecanismos legítimos de reparación",
        b: "Considerar canalizar las quejas a través de un mecanismo de reparación legítimo, como el Punto Nacional de Contacto (PNC) para las Líneas Directrices de la OCDE, en particular cuando las partes difieren sobre si la empresa causó el impacto o sobre la reparación apropiada." },
    ],
  },
];

// Estados de cada requisito (colores de la spec v8, hoja «Estados y aceptación»)
export const DD6_STATES = {
  pending: { lbl: "Sin evaluar",     ico: "○", bg: "#F0F2F5", fg: "#5A6678" },
  no:      { lbl: "No implementado", ico: "✕", bg: "#F8D5D5", fg: "#8F2323" },
  partial: { lbl: "Parcial",         ico: "◐", bg: "#FEF3D6", fg: "#7A5C0F" },
  yes:     { lbl: "Implementado",    ico: "✓", bg: "#D7EFE0", fg: "#1F6A44" },
  na:      { lbl: "No aplica",       ico: "—", bg: "#EDEFF3", fg: "#8A94A3" },
};
export const DD6_STATE_ORDER = ["yes", "partial", "no", "na"];

// Módulos a los que enlazan las etapas 2 y 3
export const DD6_MODULE_LINKS = {
  rr:  { label: "Risk Register · 2.1",  path: "/admin/ocde-risk-register" },
  ae:  { label: "Autoevaluación · 2.2", path: "/admin/self-assessments" },
  cap: { label: "CAP Tracker · 3.1",    path: "/admin/ocde-cap" },
};

function emptyReq() { return { status: "pending", evidence: "", files: [] }; }

/** Completa `data` con una entrada vacía por cada requisito que falte. */
export function dd6Normalize(data) {
  const out = {};
  DD6_STAGES.forEach((st) => {
    out[st.id] = {};
    st.reqs.forEach((r) => {
      const cur = data?.[st.id]?.[r.c];
      out[st.id][r.c] = cur ? { ...emptyReq(), ...cur, files: Array.isArray(cur.files) ? cur.files : [] } : emptyReq();
    });
  });
  return out;
}

/** Avance de etapa = (implementados + 0,5·parciales) ÷ aplicables × 100; «No aplica» fuera del denominador. */
export function dd6StageScore(st, data) {
  let yes = 0, partial = 0, applicable = 0, answered = 0;
  st.reqs.forEach((r) => {
    const s = data[st.id]?.[r.c]?.status || "pending";
    if (s !== "pending") answered++;
    if (s !== "na") {
      applicable++;
      if (s === "yes") yes++;
      if (s === "partial") partial++;
    }
  });
  const pct = applicable > 0 ? Math.round(((yes + partial * 0.5) / applicable) * 100) : 0;
  return { yes, partial, applicable, answered, total: st.reqs.length, pct };
}

/** Avance global = promedio simple de las 6 etapas; etapa completa = todos sus requisitos evaluados. */
export function dd6GlobalScore(data) {
  let sumPct = 0, stagesDone = 0;
  DD6_STAGES.forEach((st) => {
    const sc = dd6StageScore(st, data);
    sumPct += sc.pct;
    if (sc.answered === sc.total) stagesDone++;
  });
  return { avgPct: Math.round(sumPct / DD6_STAGES.length), stagesDone, total: DD6_STAGES.length };
}

/** Nivel para la tabla resumen: ≥80 avanzada · ≥50 en curso · >0 evaluados inicial. */
export function dd6Level(sc) {
  if (sc.answered === 0) return { key: "muted", lbl: "Sin evaluar" };
  if (sc.pct >= 80) return { key: "g", lbl: "Avanzada" };
  if (sc.pct >= 50) return { key: "y", lbl: "En curso" };
  return { key: "o", lbl: "Inicial" };
}
